export default "__VITE_ASSET__CLxC1dGM__"